import { Icon } from '../Icon'
import { tm } from '../tm'
import i18n from './i18n'
import type { Locales, Project } from '@captaincause/types'
import type { CSSProperties } from 'react'

interface ProjectNoteProps {
  project: Project
  className?: string
  style?: CSSProperties
  locale: Locales
}

const emptyObject = {}
export function ProjectNote({
  className = '',
  style = emptyObject,
  project,
  locale,
}: ProjectNoteProps) {
  if (!project.cc_note) return null

  const t = i18n[locale] ?? i18n.fr

  return (
    <div
      className={tm(
        'relative mx-auto flex w-full flex-col rounded-[12px_56px_12px_12px] border border-dashed border-purple bg-white p-6',
        className,
      )}
      style={style}
    >
      <Icon
        icon="stamp"
        className="absolute -right-3 -top-3 h-16 w-16"
        fill="fill-purple"
      />
      <Icon
        icon="diftman-smile"
        className="absolute -right-0 -top-0 h-10 w-10"
        fill="fill-light-beige"
        style={{ transform: 'rotateY(180deg)' }}
      />
      <div className="mb-4 font-medium text-dark-purple">{t.title}</div>
      <p className="text-sm leading-loose text-dark-purple">
        {project.cc_note}
      </p>
    </div>
  )
}
